'use client';

import React from 'react';
import { useRole } from '@/context/RoleContext';
import AppLayout from '@/components/AppLayout';
import PayrollRunHeader from './components/PayrollRunHeader';
import PayrollSummaryCards from './components/PayrollSummaryCards';
import RTISubmissionPanel from './components/RTISubmissionPanel';
import PayrollTable from './components/PayrollTable';
import { ShieldOff } from 'lucide-react';

function AccessDenied({ message }: { message: string }) {
  return (
    <div className="flex flex-col items-center justify-center h-[60vh] gap-4 text-center px-6">
      <div className="w-14 h-14 rounded-2xl bg-secondary flex items-center justify-center">
        <ShieldOff size={24} className="text-muted-foreground" />
      </div>
      <div>
        <h2 className="text-lg font-600 text-foreground mb-1">Access Restricted</h2>
        <p className="text-sm text-muted-foreground max-w-sm">{message}</p>
      </div>
    </div>
  );
}

export default function PayrollDetailsPage() {
  const { permissions, currentUser } = useRole();

  if (!permissions.canViewPayroll) {
    return (
      <AppLayout>
        <AccessDenied message={`Payroll details are not accessible for your role (${currentUser.roleLabel}). Employees can view their own payslips via My Payslips.`} />
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 py-6 space-y-5">
        <PayrollRunHeader />
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
          <div className="xl:col-span-2">
            <PayrollSummaryCards />
          </div>
          {permissions.canSubmitRTI && (
            <div>
              <RTISubmissionPanel />
            </div>
          )}
        </div>
        <PayrollTable />
      </div>
    </AppLayout>
  );
}